import { __extends } from "tslib";
import { StartDocumentAnalysisRequest, StartDocumentAnalysisResponse } from "../models/index";
import { deserializeAws_json1_1StartDocumentAnalysisCommand, serializeAws_json1_1StartDocumentAnalysisCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartDocumentAnalysisCommand = /** @class */ (function (_super) {
    __extends(StartDocumentAnalysisCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartDocumentAnalysisCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartDocumentAnalysisCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartDocumentAnalysisRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartDocumentAnalysisResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartDocumentAnalysisCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartDocumentAnalysisCommand(input, context);
    };
    StartDocumentAnalysisCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartDocumentAnalysisCommand(output, context);
    };
    return StartDocumentAnalysisCommand;
}($Command));
export { StartDocumentAnalysisCommand };
//# sourceMappingURL=StartDocumentAnalysisCommand.js.map